import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './DashboardViewer.css';

const API_URL = process.env.REACT_APP_API_URL;

const DASHBOARD_NAMES = {
  'population-level-analysis': 'Population Level Analysis',
  'patient-level-analysis': 'Patient Level Analysis',
};

const DashboardViewer = ({ dashboardId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [embedUrl, setEmbedUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEmbedUrl = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(`${API_URL}?dashboard=${dashboardId}`);
        const data = await response.json();
        if (data.embedUrl) {
          setEmbedUrl(data.embedUrl);
        } else {
          setError(data.error || 'Failed to load dashboard');
        }
      } catch (err) {
        setError('Failed to connect to API');
      }
      setLoading(false);
    };

    fetchEmbedUrl();
  }, [dashboardId]);

  const switchDashboard = (targetDashboard) => {
    navigate(`/${targetDashboard}`);
  };

  return (
    <div className="dashboard-viewer">
      <nav className="dashboard-nav">
        <div className="nav-tabs">
          <button
            className={`nav-tab ${location.pathname === '/population-level-analysis' ? 'active' : ''}`}
            onClick={() => switchDashboard('population-level-analysis')}
          >
            {DASHBOARD_NAMES['population-level-analysis']}
          </button>
          <button
            className={`nav-tab ${location.pathname === '/patient-level-analysis' ? 'active' : ''}`}
            onClick={() => switchDashboard('patient-level-analysis')}
          >
            {DASHBOARD_NAMES['patient-level-analysis']}
          </button>
        </div>
      </nav>
      <div className="dashboard-container">
        {loading && (
          <div className="placeholder">
            <h2>Loading dashboard...</h2>
          </div>
        )}
        {error && (
          <div className="placeholder">
            <h2>Error</h2>
            <p>{error}</p>
          </div>
        )}
        {embedUrl && (
          <iframe
            src={embedUrl}
            width="100%"
            height="100%"
            frameBorder="0"
            title={DASHBOARD_NAMES[dashboardId]}
          />
        )}
      </div>
    </div>
  );
};

export default DashboardViewer;
